var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box"},[_vm._m(0),_c('div',{staticClass:"card-box_container"},_vm._l((_vm.dataList),function(item){return _c('a',{key:item.name,attrs:{"href":item.link,"target":"_blank"}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box_title"},[_c('span',[_vm._v("友情链接")])])
}]

export { render, staticRenderFns }